module.exports = __webpack_public_path__ + "static/media/motorIcon.a0f30b6e.svg";